import { render, staticRenderFns } from "./medicina-ocupacional2.vue?vue&type=template&id=d7e1af58&"
import script from "./medicina-ocupacional2.vue?vue&type=script&lang=js&"
export * from "./medicina-ocupacional2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports